import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { OrangeBtn } from '../newComponents/Button/ButtonSkin';

import { Formik, Form } from 'formik';
import TextField from '../newComponents/Form/TextField';
import TextAreaField from '../newComponents/Form/TextAreaField';
import ReCaptcha from 'react-google-recaptcha';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';

import * as Yup from 'yup';
import { countryCodes } from '../translations/countryCodes';
import { IoClose } from 'react-icons/io5';
import { Link } from 'react-router-dom';

import { sendContactEmail } from '../services/sendContactEmail';

const ModalFormBoxContainer = styled.div`
    box-shadow: 2px 4px 15px 0px rgba(0, 0, 0, 0.05);
    overflow-y: auto;
    width: 100%;
    max-width: 505px;

    .form-box {
        position: relative;
        .form-title {
            font-size: 19px;
            line-height: 27px;
            font-weight: 600;
            margin-bottom: 27px;
        }
        .form-section {
            gap: 16px;
            .one-col {
                .consent-box {
                    input[type='checkbox'] {
                        width: 20px;
                        height: 20px;
                    }
                }
            }
            .textArea {
                height: auto;
            }
        }
        .cta {
            text-align: right;
            margin-top: 20px;
            margin-bottom: 7px;
            button {
                width: auto;
            }
            .login-cta {
                line-height: 150%;
                margin-top: 27px;
                a {
                    font-weight: 600;
                    color: ${({ theme }) => theme.colors.title_green};
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .thankyou-box {
        padding: 100px 0;
    }

    @media (max-width: ${({ theme }) => theme.media.tab}) {
        .form-box {
            padding-top: 15px;
            .form-title {
                font-size: 16px;
                line-height: 180%;
                margin-bottom: 10px;
            }
            .cta {
                .login-cta {
                    margin-top: 10px;
                }
            }
        }
        .form-section {
            gap: 24px;
        }
    }
`;

const ModalFormBox = ({ closeBtn, subjectLine, intl }) => {
    const reCaptchaRefMessage = useRef(null);
    const [showError, setShowError] = useState(false);
    const [isEmailSent, setIsEmailSent] = useState(false);

    // firstName
    const firstNameLabel = intl.formatMessage({
        id: 'ModalForm.firstNameLabel',
    });
    const firstNamePlaceholder = intl.formatMessage({
        id: 'ModalForm.firstNamePlaceholder',
    });

    // lastName
    const lastNameLabel = intl.formatMessage({
        id: 'ModalForm.lastNameLabel',
    });
    const lastNamePlaceholder = intl.formatMessage({
        id: 'ModalForm.lastNamePlaceholder',
    });
    const emailLabel = intl.formatMessage({
        id: 'ModalForm.emailLabel',
    });
    const emailPlaceholder = intl.formatMessage({
        id: 'ModalForm.emailPlaceholder',
    });
    const subjectLabel = intl.formatMessage({
        id: 'ModalForm.subjectLabel',
    });
    const subjectPlaceholder = intl.formatMessage({
        id: 'ModalForm.subjectPlaceholder',
    });
    const messageLabel = intl.formatMessage({
        id: 'ModalForm.messageLabel',
    });
    const messagePlaceholder = intl.formatMessage({
        id: 'ModalForm.messagePlaceholder',
    });

    const initialValues = {
        firstName: '',
        lastName: '',
        email: '',
        subject: subjectLine,
        message: '',
    };

    const validationSchema = Yup.object({
        firstName: Yup.string().required(<FormattedMessage id="ModalForm.firstName.errMsg" />),
        lastName: Yup.string().required(<FormattedMessage id="ModalForm.lastName.errMsg" />),
        email: Yup.string()
            .email(<FormattedMessage id="ModalForm.emailInv.errMsg" />)
            .required(<FormattedMessage id="ModalForm.emailReq.errMsg" />),
        subject: Yup.string().required(<FormattedMessage id="ModalForm.subject.errMsg" />),
        message: Yup.string().required(<FormattedMessage id="ModalForm.message.errMsg" />),
    });

    const onSubmit = async values => {
        const { ...restValues } = values;
        console.log('valuesform', values);
        try {
            let captchaToken;
            if (reCaptchaRefMessage.current) {
                captchaToken = await reCaptchaRefMessage.current.executeAsync();
                reCaptchaRefMessage.current.reset();
            }

            if (!!captchaToken && !!restValues) {
                const proposalData = {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    email: values.email,
                    subject: values.subject,
                    message: values.message,
                };
                const result = await sendContactEmail(proposalData, captchaToken);
                if (result.status === 'success') {
                    setIsEmailSent(true);
                } else {
                    setShowError(result.message);
                }
            } else {
                console.error('Failed to generate captchaToken');

                return; // Exit early if captchaToken is undefined
            }
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <>
            <ModalFormBoxContainer className="modal-box-class">
                {/* form starts */}
                <div className="input-box-section">
                    <label>
                        <FormattedMessage id="ModalForm.Contact.Title" />
                    </label>
                </div>

                {showError && (
                    <div className="error-text small">
                        <FormattedMessage id="ModalForm.emailFailed" />
                    </div>
                )}
                {!isEmailSent && (
                    <div className="form-box w-full mx-auto flex flex-col">
                        <Formik
                            enableReinitialize={true}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmit}
                        >
                            {formik => {
                                return (
                                    <Form onChange={() => setShowError(false)}>
                                        <div className="form-section flex flex-col">
                                            <div className="one-col">
                                                <div className="input-box-section">
                                                    <label className="small">
                                                        To : community@regenera.earth
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="two-col flex space-between">
                                                <div className="input-box-section">
                                                    <TextField
                                                        type="text"
                                                        label={firstNameLabel}
                                                        name="firstName"
                                                        placeholder={firstNamePlaceholder}
                                                        aria-describedby="firstnamehelp"
                                                        value={formik.values.firstName}
                                                        className={`form-control  ${formik.touched
                                                            .firstName &&
                                                            formik.errors.firstName &&
                                                            'input-error'}`}
                                                    />
                                                </div>
                                                <div className="input-box-section">
                                                    <TextField
                                                        type="text"
                                                        label={lastNameLabel}
                                                        name="lastName"
                                                        placeholder={lastNamePlaceholder}
                                                        value={formik.values.lastName}
                                                        aria-describedby="lastnamehelp"
                                                        className={`form-control  ${formik.touched
                                                            .lastName &&
                                                            formik.errors.lastName &&
                                                            'input-error'}`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="one-col">
                                                <div className="input-box-section">
                                                    <TextField
                                                        type="email"
                                                        label={emailLabel}
                                                        name="email"
                                                        placeholder={emailPlaceholder}
                                                        aria-describedby="emailhelp"
                                                        className={`form-control  ${formik.touched
                                                            .email &&
                                                            formik.errors.email &&
                                                            'input-error'}`}
                                                    />
                                                </div>
                                            </div>

                                            <div className="one-col">
                                                <div className="input-box-section">
                                                    <TextField
                                                        type="text"
                                                        label={subjectLabel}
                                                        name="subject"
                                                        placeholder={subjectPlaceholder}
                                                        aria-describedby="subjecthelp"
                                                        className={`form-control  ${formik.touched
                                                            .subject &&
                                                            formik.errors.subject &&
                                                            'input-error'}`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="one-col">
                                                <div className="input-box-section">
                                                    <TextAreaField
                                                        type="textarea"
                                                        label={messageLabel}
                                                        name="message"
                                                        rows="3"
                                                        placeholder={messagePlaceholder}
                                                        aria-describedby="messagehelp"
                                                        className={`form-control textArea ${formik
                                                            .touched.message &&
                                                            formik.errors.message &&
                                                            'input-error'}`}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="cta mx-auto">
                                            <ReCaptcha
                                                ref={reCaptchaRefMessage}
                                                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                                size="invisible"
                                            />
                                            <OrangeBtn
                                                type="submit"
                                                disabled={!formik.isValid}
                                                className={!formik.isValid ? 'disabled' : null}
                                            >
                                                <FormattedMessage id="ModalForm.Send" />
                                            </OrangeBtn>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                )}
                {/* forms ends */}

                {/* thank you box */}
                {isEmailSent && (
                    <div className="thankyou-box text-center">
                        <h3>
                            <FormattedMessage id="ModalForm.Thanks" />
                        </h3>
                        <FormattedMessage
                            id="ModalForm.Contact.Thanks.Description"
                            values={{
                                p: chunks => <p>{chunks}</p>,
                            }}
                        />
                    </div>
                )}

                {/* thank you box ends */}
                <button
                    onClick={closeBtn}
                    className="modal-close-btn flex items-center justify-center"
                >
                    <IoClose />
                </button>
            </ModalFormBoxContainer>
        </>
    );
};

export default compose(injectIntl)(ModalFormBox);
